import { LessonStatus } from "@/components/course/tree/types";
import { sectionKey } from "@/stores/sectionCompletionStore";
import { CourseTreeNodeTypeEnum, type CourseTreeNode } from "@/types/generated";

const lessonAlreadyStarted = (status: LessonStatus | undefined): boolean =>
  status === LessonStatus.InProgress || status === LessonStatus.Completed;

/**
 * Chapter whose introduction is already checked, while its first lesson has
 * not started. A dashboard module click should open that lesson.
 */
const unveiledChapterForCheckedIntro = (
  moduleId: string,
  structure: readonly CourseTreeNode[] | undefined,
  completedSectionKeys: ReadonlySet<string>,
  lessonStatusById: Readonly<
    Record<string, { status: LessonStatus } | undefined>
  >
): string | null => {
  const moduleNode = structure?.find(
    (node) =>
      node.type === CourseTreeNodeTypeEnum.Module && node.id === moduleId
  );
  const chapters =
    moduleNode?.children?.filter(
      (child) => child.type === CourseTreeNodeTypeEnum.Chapter
    ) ?? [];

  const openChapter = chapters.find((chapter) => {
    const introChecked = completedSectionKeys.has(
      sectionKey("intro", chapter.id)
    );
    if (!introChecked) return false;

    const firstLesson = chapter.children?.find(
      (child) => child.type === CourseTreeNodeTypeEnum.Subchapter
    );
    if (!firstLesson) return false;

    return !lessonAlreadyStarted(lessonStatusById[firstLesson.id]?.status);
  });

  return openChapter?.id ?? null;
};

export { unveiledChapterForCheckedIntro };
